export const getRegionDataByCityUrl = "/api/v3/defs/region/:cityId";
export const getRegionNamesUrl = "/api/v3/defs/region/names";
export const getRegionListByTypeUrl = "/api/v3/defs/region/search";
